import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import PermissionBoxWrapper from './styles/permissionbox.style';
import LocalVideoPreview from '../../components/LocalVideoPreview/LocalVideoPreview';
import ExitModal from '../../components/exitModal/exitModal';
// import JoinModal from '../../components/joinModal/joinModal';
import Controls from '../../components/Controls/videoRoom/Controls';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { getInitials } from '../../utils/getInititials';


function AudioVideoPermission() {
				return(
					<div className="audiovideoPermission">
					<div className="header-icons">
						<button className="permission-control m-off"></button>
						<button className="permission-control v-off"></button>
					</div>
					<div className="user-icon">
						<img src="https://static.sendbird.com/sample/profiles/profile_35_512px.png" />
					</div>
					</div>
					)
}
function PermissionVerification(props) {
	const { localTracks } = useVideoContext();

	const videoTrack = localTracks.find(track => track.name === 'camera');
	const audioTrack = localTracks.find(track => track.kind === 'audio');

	audioTrack && audioTrack.disable();
	videoTrack && videoTrack.stop();
	
	const { verifyUser } = props;
	return(
		<div className="permissionVerification">
			<div className="permission-text">Verify your camera and microphone before a call</div>
			<button className="verify-button" onClick={verifyUser}>verify</button>
		</div>
		)
}

function VideoThumbnailBox(props) {

	return(
		<div className="videoThumbnailBox">
				<div className="initial-name">{getInitials(props.camName || "")}</div> 
				<LocalVideoPreview />
				<Controls hideFullScreen={true} videoThumbnail={true}/>
		</div>
		)
}


function PermissionNotGranted(props) {
	const { localTracks, 
		getLocalVideoTrack } = useVideoContext();

	const videoTrack = localTracks.find(track => track.name === 'camera');
	const audioTrack = localTracks.find(track => track.kind === 'audio');
	
	const [visible, setVisible] = useState(false);
	const [firstVideo, setFirstVideo] = useState(true);
	
	if((audioTrack && videoTrack) || props.verified){
		if(!props.verified){
			props.verifyUser();
		}
		if(videoTrack && videoTrack.isStopped && firstVideo){
			getLocalVideoTrack();
		}
		if(firstVideo){
			audioTrack && audioTrack.enable();
			setFirstVideo(false);
		}
		return <VideoThumbnailBox camName={props.camName}/>
	}

	audioTrack && audioTrack.disable();
	videoTrack && videoTrack.stop();
	
	return(
		<div className="permissionNotGranted">
			<div className="header-icons">
				<button className="permission-control mike"></button>
				<button className="permission-control camera"></button>
			</div>
			<div className="no-permission-text">Your camera and microphone are not enabled yet. Allow access by changing your settings using the<span><img src="/images/chrome-camera-block.png" width="15" /></span>&nbsp;icon in the address bar. </div>
			<a  className="moreInfo" onClick={() => setVisible(true)}>more info</a>
			<Modal
				className="cameraAcessModal"
				width={700}
				visible={visible}
				onCancel={() => setVisible(false)}
				footer=""
				>
					<div className="cameraAcessContent">
						<h1>Camera and microphone access</h1>
						<p>To double check your camera and microphone are enables:</p>
						<ul>
							<li>Select the lock icon positioned on the right of your address bar.</li>
							<li>Make sure the dropdown next to the camera and microphone are allowed access</li>
							<li>Refresh the browser tab (cmd + R on Mac, or Ctrl + R / F5 on Windows).</li>
						</ul>
						<div className="permission-screenshot">
							<img src="/images/chrome-permissions.png" width="309" />
						</div>
					</div>
			 </Modal>
			
		</div>
		)
}



class PermissionBox extends Component {
	constructor(props) {
		super(props);
		this.state={
			verified:false,
			showExitModal:false,
			showJoinModal:false
		}
	}

	verifyUser = () => {
		this.setState({
			verified: true
		});
	}

	hideExitModal = () =>{
		this.setState({
			showExitModal: false
		});	
	}
	hideJoinModal = () =>{
		this.setState({
			showJoinModal: false
		});	
	}

	render() {
		const { showLocalVideo, verifyUser, camName } = this.props;
		
		return (

			<PermissionBoxWrapper>
			<div className={'permissionBoxContainer'}>
				{showLocalVideo ?
				<PermissionNotGranted  camName={camName} verified={this.state.verified} verifyUser={this.verifyUser}/>:
				<PermissionVerification verifyUser={verifyUser} />
				}
			</div>
			 <ExitModal visible={this.state.showExitModal}  onCancel={this.hideExitModal} /> 
			 {/* <JoinModal visible={this.state.showJoinModal}  onCancel={this.hideJoinModal} />  */}
			</PermissionBoxWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(PermissionBox);
